export default __webpack_public_path__ + "static/media/Screenshot_5.f261e259.png";